import React from "react";
import { Link } from "react-router-dom";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import StarRating from "../Star-Component/StarRating";

const BookCard = ({
  thumbnail,
  name,
  price,
  offer_price,
  offer_discount,
  rating,
  id,
}) => {
  return (
    <Link
      to={
        UNPROTECTED_ROUTES?.bookDetails +
        `/${id}` +
        UNPROTECTED_ROUTES?.description
      }
    >
      <div className="p-2 border border-gray-200 rounded-lg lg:gap-2 gap-3 h-[18rem] bg-white shadow-lg lg:text-[1rem] text-sm">
        {/* Course Image */}
        <div>
          <img
            src={thumbnail}
            alt={name}
            className="md:w-[20rem] md:h-[8rem] rounded-lg w-full h-full"
            loading="lazy"
          />
        </div>
        {/* Course Rating */}
        <div>
          <StarRating rating={Math.floor(rating)} />
        </div>
        <div className="font-bold">{name}</div>
        {/* Price and Button */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 items-center justify-end">
          <div className="flex items-center gap-1">
            {/* Discount percentage */}
            <div className="mb-[13px] md:mb-0">
              {offer_discount !== "0" && offer_discount !== null ? (
                <div className="rounded-l-full rounded-r-full text-white bg-[#5A277C] p-1 w-10 text-xs text-center">
                  {offer_discount}% off
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="flex flex-col">
              {/* Original price */}
              {offer_discount !== "0" && offer_discount !== null && (
                <div className="line-through text-gray-500">₹{price}</div>
              )}
              {/* Offer price */}
              <div className="text-[#5A277C] font-bold">
                ₹
                {offer_discount !== "0" && offer_discount !== null
                  ? offer_price
                  : price}
              </div>
            </div>
          </div>
          <div className="flex items-start md:items-end md:justify-end justify-center mb-[13px] md:mb-0">
            <Link
              to={
                UNPROTECTED_ROUTES?.bookDetails +
                `/${id}` +
                UNPROTECTED_ROUTES?.description
              }
            >
              <button
                className="text-[#03B3C3] rounded-xl cursor-pointer px-1 py-1"
                style={{
                  backgroundColor: "rgba(30, 203, 219, 0.15)",
                  fontWeight: 700,
                }}
              >
                Explore
              </button>
            </Link>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BookCard;
